import type { Answers } from "../../../../features/questionnaire";
import type { Display } from "../../Section/Question/QuestionFactory";
import type { Answer, QuestionProps } from "../../Section/Question/types";
import type { ValidationResponse } from "../question/rules/types";

export type CompareOperator =
  | "eq"
  | "neq"
  | "lt"
  | "lte"
  | "gt"
  | "gte"
  | "in"
  | "nin"
  | "matches";

export type EvaluatedAnswer = {
  question: string;
  value: Answer;
};

export type Rule = {
  id: string;
  operator: CompareOperator;
  value?: string;
  expression?: string;
  leftValue?: Answer;
  leftExpression?: string;
  evaluatedAnswers?: EvaluatedAnswer[];
};

export type Combinator = {
  id: string;
  combinator: "and" | "or";
  rules: readonly (Rule | Combinator)[];
  skipIfAnyUnanswered?: boolean;
};

export type RuleSet = (Rule | Combinator) & {
  message?: string;
};

export type RuleOutcome = {
  valid: boolean;
  message?: string;
};

export type VisibilityMap = Record<string, boolean> | undefined;

export type EvaluateRule = (
  answers: Answers,
  visibilityMap: VisibilityMap,
) => ValidationResponse;

// Type helpers
export const isRule = (rule: Rule | Combinator | RuleSet): rule is Rule => {
  return "operator" in rule && !("rules" in rule);
};

export const isRuleSet = (
  rule: Rule | Combinator | RuleSet,
): rule is RuleSet => {
  return "message" in rule;
};

export type PartialQuestion = Pick<
  QuestionProps,
  | "name"
  | "isRequired"
  | "required"
  | "validation"
  | "visible"
  | "suggested"
  | "errorMessage"
> & {
  display?: Display;
};
